import axios from 'axios';

export const addProtocol = async (name, folder) => {
  const url = `${process.env.REACT_APP_API_URL}/folders/${folder.id}/protocols`;
  const headers = {
    'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
    'Content-Type': 'application/json'
  };
  try {
    const response = await axios.post(url,{'name': name},{headers: headers});
    return response;
  } catch (error) {
    const {response} = error;
    return response;
  }
}


